import React from "react";

const Dimensions = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 5.33594L4 3.33594M4 3.33594L6 5.33594M4 3.33594V12.6693M2 10.6693L4 12.6693M4 12.6693L6 10.6693M8.66667 4.0026H13.3333M8.66667 8.0026H13.3333M8.66667 12.0026H13.3333" stroke="#252525" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>                    
    );
}
export default Dimensions
